// Helper for tracking duplicate cabinet analytics
import { CABINET_VISUALIZER_DIGITAL_DATA } from '../../../../../constants';

/**
 * Fires both overlay and add-to-wall analytics for cabinet duplication.
 * @param {Function} trackChooseCabinetOverlayEvent - Overlay analytics function from zustand store
 * @param {Function} trackAddItemToWallAnalyticsEvent - Add-to-wall analytics function from zustand store
 * @param {string|number} basePrice - The base price of the duplicated cabinet
 * @param {string|number} itemId - The SKU or ID of the duplicated cabinet
 * @param {number} [quantity=1] - The quantity duplicated (default 1)
 */
export function trackAddDuplicateAnalytics(
  trackChooseCabinetOverlayEvent,
  trackAddItemToWallAnalyticsEvent,
  basePrice,
  itemId,
  quantity = 1
) {
  trackChooseCabinetOverlayEvent({
    eventName: CABINET_VISUALIZER_DIGITAL_DATA.CONFIGURATOR.DUPLICATE_CABINET,
    eventType: CABINET_VISUALIZER_DIGITAL_DATA.ACTION.DUPLICATE_CABINET
  });
  trackAddItemToWallAnalyticsEvent({
    itemInfo: {
      quantity,
      productInfo: { sku: String(itemId) },
      price: { basePrice }
    }
  });
}
